<template lang="pug">
div
  v-row(wrap)
    v-col(cols="12", md="4")
      StandardChart(:input="totalData")
    v-col(cols="12", md="4")
      StandardChart(:input="countData")
    v-col(cols="12", md="4")
      StandardChart(:input="impressionData")
  Table.my-5(
    :report="result",
    title="Monthly Online Sales Summary",
    :year="year"
  )
</template>

<script>
import { mapGetters } from "vuex";
import _ from "underscore";
import { EventBus } from "@/event-bus.js";
import Table from "./Table/index";

export default {
  components: { Table },
  props: ["year"],
  data() {
    return {
      result: [],
      impressionResult: [],
    };
  },
  computed: {
    ...mapGetters(["biz", "chainAccounts"]),
    chain() {
      return this.chainAccounts?.find((o) => o.bizs.includes(this.biz._id));
    },
    totalData() {
      if (!this.result) return null;
      const labels = this.result.map((o) => o.month);
      const values = this.result.map((o) => Math.round(o.total * 100) / 100);
      return {
        title: "Monthly Sales",
        labels,
        values,
        isCurrency: true,
      };
    },
    countData() {
      if (!this.result) return null;
      const labels = this.result.map((o) => o.month);
      const values = this.result.map((o) => o.count);
      return {
        title: "Monthly #Sales",
        labels,
        values,
      };
    },
    impressionData() {
      if (!this.impressionResult) return null;
      const labels = this.impressionResult.map((o) => o.month);
      const values = this.impressionResult.map((o) => o.count);
      return {
        title: "Monthly Impression",
        labels,
        values,
      };
    },
  },
  watch: {
    year() {
      this.load();
    },
  },
  mounted() {
    this.load();
    EventBus.$on("switch-biz", this.load);
  },
  destroyed() {
    EventBus.$off("switch-biz", this.load);
  },
  methods: {
    load() {
      if (!this.biz) return;
      const params = {
        bizId: this.biz._id,
        year: this.year,
        chain: this.chain,
      };
      this.loadSales(params);
      this.loadImpression(params);
    },
    async loadSales(params) {
      const { data } = await this.axios.post("/orders/online/monthly", params);
      this.result = _.chain(data)
        .sortBy((o) => o.month)
        .sortBy((o) => o.year)
        .value();
    },
    async loadImpression(params) {
      const url = "/bizs/impression/monthly";
      const { data } = await this.axios.post(url, params);
      this.impressionResult = _.chain(data)
        .sortBy((o) => o.month)
        .sortBy((o) => o.year)
        .value();
    },
  },
};
</script>
